import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdCourseTemplate from '@/course-templates/components/ed-course-template/ed-course-template.component.vue';
import { CourseTemplate } from '@/course-templates/models/course-template.model';
import { Status } from '@/models/status.model';
import EdCardsLoading from '@/components/cards/ed-cards-loading/ed-cards-loading.component.vue';
import { ALL_CONTENT_ROUTES } from '@/app/private/my-content/views/all/all.router';

@Component({
  components: {
    EdCourseTemplate
  }
})
export default class EdCourseTemplateSectionComponent extends Vue {

  @Prop() readonly courseTemplates: CourseTemplate[];
  @Prop() readonly status: Status;
  @Prop({default: ''}) readonly menuName: string;

  public readonly refreshSection: string = 'refreshSection';
  
  public loadingComponent: any = EdCardsLoading;

  get sectionClass(): any {
    return {
      'error': this.status.error,
      'empty': this.isEmpty
    };
  }

  get isEmpty() {
    return this.status.load && this.courseTemplates.length == 0;
  }

  doRefreshSection() {
    this.$emit(this.refreshSection);
  }

  goToMyContent() {
    this.$router.push({ name: ALL_CONTENT_ROUTES.TEMPLATES.NAME });
  }

}